export const NAV_ITEMS = ["Nosotros", "Sectores", "Productos", "Contáctanos"]

